/**
 * Extract error message from API response
 * Handles both array and string error formats
 * Ex: `{"non_field_errors": ["Can only futile allocated jobs"]}`
 */
export function getApiErrorText(responseData: unknown): string {
  if (responseData && typeof responseData === 'object') {
    const firstValue = Object.values(responseData)[0];
    if (Array.isArray(firstValue) && firstValue.length > 0) {
      return String(firstValue[0]);
    }
    if (typeof firstValue === 'string') {
      return firstValue;
    }
  }
  return '';
}
